import { handleCustomUDL } from "@utils/UDLUtils";

export class DownloadList {
  private el: HTMLElement;
  private abortController: AbortController;

  constructor(el: HTMLElement) {
    this.el = el;
    this.abortController = new AbortController();
  }

  init(): void {
    const signal = this.abortController.signal;

    this.el
      .querySelectorAll<HTMLAnchorElement>(".entry-link")
      .forEach((link) => {
        link.addEventListener(
          "click",
          (e) => {
            const target = e.currentTarget as HTMLAnchorElement;
            const customParams = {
              link_url: target.href || "",
              link_text:
                target.getAttribute("data-resource-tracking-title") ||
                target.querySelector(".title")?.textContent ||
                "",
            };
            this.pushClickData(customParams);
          },
          { signal },
        );
      });
  }

  private pushClickData(params: Record<string, string>): void {
    handleCustomUDL("download_list_teaser_asset_open", params);
  }

  destroy(): void {
    this.abortController.abort();
  }

  static initAll(root: Document | HTMLElement = document): void {
    root
      .querySelectorAll<HTMLElement>('[data-component="downloadlist"]')
      .forEach((el) => {
        new DownloadList(el).init();
      });
  }
}
